/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfirmAccountRequest,
  CreateAccountRequest,
  ExchangeCodeForTokens200Response,
  ExchangeCodeForTokensRequest,
  LoginAccount200Response,
  LoginAccountRequest,
  RefreshTokensRequest,
  ResetPasswordWithTokenRequest,
  RespondToAuthChallengeRequest,
  SendForgotPasswordEmailRequest,
} from '../models/index';
import {
    ConfirmAccountRequestFromJSON,
    ConfirmAccountRequestToJSON,
    CreateAccountRequestFromJSON,
    CreateAccountRequestToJSON,
    ExchangeCodeForTokens200ResponseFromJSON,
    ExchangeCodeForTokens200ResponseToJSON,
    ExchangeCodeForTokensRequestFromJSON,
    ExchangeCodeForTokensRequestToJSON,
    LoginAccount200ResponseFromJSON,
    LoginAccount200ResponseToJSON,
    LoginAccountRequestFromJSON,
    LoginAccountRequestToJSON,
    RefreshTokensRequestFromJSON,
    RefreshTokensRequestToJSON,
    ResetPasswordWithTokenRequestFromJSON,
    ResetPasswordWithTokenRequestToJSON,
    RespondToAuthChallengeRequestFromJSON,
    RespondToAuthChallengeRequestToJSON,
    SendForgotPasswordEmailRequestFromJSON,
    SendForgotPasswordEmailRequestToJSON,
} from '../models/index';

export interface ConfirmAccountOperationRequest {
    confirmAccountRequest: ConfirmAccountRequest;
}

export interface CreateAccountOperationRequest {
    createAccountRequest: CreateAccountRequest;
}

export interface ExchangeCodeForTokensOperationRequest {
    exchangeCodeForTokensRequest: ExchangeCodeForTokensRequest;
}

export interface LoginAccountOperationRequest {
    loginAccountRequest: LoginAccountRequest;
}

export interface RefreshTokensOperationRequest {
    refreshTokensRequest: RefreshTokensRequest;
}

export interface ResetPasswordWithTokenOperationRequest {
    resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest;
}

export interface RespondToAuthChallengeOperationRequest {
    respondToAuthChallengeRequest: RespondToAuthChallengeRequest;
}

export interface SendForgotPasswordEmailOperationRequest {
    sendForgotPasswordEmailRequest: SendForgotPasswordEmailRequest;
}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     * Confirm Account
     * Confirm Account
     */
    async confirmAccountRaw(requestParameters: ConfirmAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginAccount200Response>> {
        if (requestParameters['confirmAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmAccountRequest',
                'Required parameter "confirmAccountRequest" was null or undefined when calling confirmAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmAccountRequestToJSON(requestParameters['confirmAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Confirm Account
     * Confirm Account
     */
    async confirmAccount(requestParameters: ConfirmAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginAccount200Response> {
        const response = await this.confirmAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create account
     * Create Account
     */
    async createAccountRaw(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createAccountRequest',
                'Required parameter "createAccountRequest" was null or undefined when calling createAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAccountRequestToJSON(requestParameters['createAccountRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create account
     * Create Account
     */
    async createAccount(requestParameters: CreateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exchange OAuth code for tokens
     * Exchange OAuth Code for Tokens
     */
    async exchangeCodeForTokensRaw(requestParameters: ExchangeCodeForTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExchangeCodeForTokens200Response>> {
        if (requestParameters['exchangeCodeForTokensRequest'] == null) {
            throw new runtime.RequiredError(
                'exchangeCodeForTokensRequest',
                'Required parameter "exchangeCodeForTokensRequest" was null or undefined when calling exchangeCodeForTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/tokens`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExchangeCodeForTokensRequestToJSON(requestParameters['exchangeCodeForTokensRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExchangeCodeForTokens200ResponseFromJSON(jsonValue));
    }

    /**
     * Exchange OAuth code for tokens
     * Exchange OAuth Code for Tokens
     */
    async exchangeCodeForTokens(requestParameters: ExchangeCodeForTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExchangeCodeForTokens200Response> {
        const response = await this.exchangeCodeForTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Login account
     * Login Account
     */
    async loginAccountRaw(requestParameters: LoginAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginAccount200Response>> {
        if (requestParameters['loginAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'loginAccountRequest',
                'Required parameter "loginAccountRequest" was null or undefined when calling loginAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginAccountRequestToJSON(requestParameters['loginAccountRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Login account
     * Login Account
     */
    async loginAccount(requestParameters: LoginAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginAccount200Response> {
        const response = await this.loginAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refresh tokens
     * Refresh Tokens
     */
    async refreshTokensRaw(requestParameters: RefreshTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginAccount200Response>> {
        if (requestParameters['refreshTokensRequest'] == null) {
            throw new runtime.RequiredError(
                'refreshTokensRequest',
                'Required parameter "refreshTokensRequest" was null or undefined when calling refreshTokens().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshTokensRequestToJSON(requestParameters['refreshTokensRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Refresh tokens
     * Refresh Tokens
     */
    async refreshTokens(requestParameters: RefreshTokensOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginAccount200Response> {
        const response = await this.refreshTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset password with token
     * Reset Password with Token
     */
    async resetPasswordWithTokenRaw(requestParameters: ResetPasswordWithTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginAccount200Response>> {
        if (requestParameters['resetPasswordWithTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'resetPasswordWithTokenRequest',
                'Required parameter "resetPasswordWithTokenRequest" was null or undefined when calling resetPasswordWithToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordWithTokenRequestToJSON(requestParameters['resetPasswordWithTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset password with token
     * Reset Password with Token
     */
    async resetPasswordWithToken(requestParameters: ResetPasswordWithTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginAccount200Response> {
        const response = await this.resetPasswordWithTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Respond to Auth Challenge
     * Respond to Auth Challenge
     */
    async respondToAuthChallengeRaw(requestParameters: RespondToAuthChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginAccount200Response>> {
        if (requestParameters['respondToAuthChallengeRequest'] == null) {
            throw new runtime.RequiredError(
                'respondToAuthChallengeRequest',
                'Required parameter "respondToAuthChallengeRequest" was null or undefined when calling respondToAuthChallenge().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/respond`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RespondToAuthChallengeRequestToJSON(requestParameters['respondToAuthChallengeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginAccount200ResponseFromJSON(jsonValue));
    }

    /**
     * Respond to Auth Challenge
     * Respond to Auth Challenge
     */
    async respondToAuthChallenge(requestParameters: RespondToAuthChallengeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginAccount200Response> {
        const response = await this.respondToAuthChallengeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send forgot password email
     * Send Forgot Password Email
     */
    async sendForgotPasswordEmailRaw(requestParameters: SendForgotPasswordEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sendForgotPasswordEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendForgotPasswordEmailRequest',
                'Required parameter "sendForgotPasswordEmailRequest" was null or undefined when calling sendForgotPasswordEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/forgot-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendForgotPasswordEmailRequestToJSON(requestParameters['sendForgotPasswordEmailRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send forgot password email
     * Send Forgot Password Email
     */
    async sendForgotPasswordEmail(requestParameters: SendForgotPasswordEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendForgotPasswordEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
